export const SectionHeading = ({ eyebrow, title, sub, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    {eyebrow && <span className="eyebrow">{eyebrow}</span>}
    <h2 className="mt-4 font-display font-extrabold uppercase tracking-tight text-slate-900 text-3xl sm:text-4xl lg:text-5xl leading-[0.95]">{title}</h2>
    {sub && <p className="mt-5 text-slate-600 text-base md:text-lg leading-relaxed">{sub}</p>}
  </div>
);

export const PageHero = ({ eyebrow, title, sub, image, testid }) => (
  <section className="relative grain overflow-hidden border-b border-slate-200" data-testid={testid}>
    {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
    <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/40" />
    <div className="absolute inset-0 grid-lines" />
    <div className="relative z-[2] container-x py-20 md:py-28">
      <span className="eyebrow rise">{eyebrow}</span>
      <h1 className="rise d1 mt-5 font-display font-black uppercase text-slate-900 text-4xl sm:text-5xl lg:text-6xl leading-[0.92] max-w-4xl">{title}</h1>
      {sub && <p className="rise d2 mt-6 text-slate-700 text-base md:text-lg max-w-2xl leading-relaxed">{sub}</p>}
    </div>
  </section>
);
